import { CityService } from '@porterin/feature/src/shared/cities/domain/entities/CitiesEntity';
import { CommonImage } from '@porterin/feature/src/shared/types/CommonVM';
import React from 'react';

import styles from '../styles/CategorySelector.module.scss';

import CategorySelectCmp from './CategorySelectCmp';

interface CategorySelectorCmpProps {
  onCategorySelect: (service_type: string) => void;
  category_cards_data: CityService[];
  arrow_icon: CommonImage;
}

function CategorySelectorCmp({
  onCategorySelect,
  category_cards_data,
  arrow_icon,
}: Readonly<CategorySelectorCmpProps>): React.ReactElement {
  return (
    <div className={styles['category-selector-container']}>
      <div className={styles['category-selector-cards']}>
        {category_cards_data.map(category_details => (
          <CategorySelectCmp
            key={category_details.service_type}
            category_details={category_details}
            onCategorySelect={onCategorySelect}
            arrow_icon={arrow_icon}
          />
        ))}
      </div>
    </div>
  );
}

export default CategorySelectorCmp;
